import { useEffect, useState } from 'react';
import BaseService from '../../../../../services/BaseService';

const NIVEL_ORDEM = { POLO: 0, GERENCIA: 1, MALHA: 2 };

const vazio = {
  procedimentos: {},
  gerais: [],
  porTipoServico: {},
  nsmps: {},
  regiao: null,
};

export const idsGerais = (data) =>
  (data?.gerais || []).filter((id) => data?.procedimentos?.[id]);

export const idsServicoDaNsmp = (data, nsmpId) => {
  const nsmp = data?.nsmps?.[nsmpId];
  if (!nsmp || nsmp.origem !== 'ESTRUTURADO') return [];
  const vistos = new Set();
  const ids = [];
  (nsmp.tipoServicoIds || []).forEach((tipoId) => {
    (data?.porTipoServico?.[tipoId] || []).forEach((id) => {
      if (!id || vistos.has(id) || !data?.procedimentos?.[id]) return;
      vistos.add(id);
      ids.push(id);
    });
  });
  return ids;
};

export const contagemProcedimentosServico = (data, nsmpId) =>
  idsServicoDaNsmp(data, nsmpId).length;

export const idsRegiaoCompleta = (data) => {
  const dict = data?.procedimentos || {};
  return Object.keys(dict).sort((a, b) => {
    const nivelA = NIVEL_ORDEM[dict[a]?.escopo?.nivel] ?? 3;
    const nivelB = NIVEL_ORDEM[dict[b]?.escopo?.nivel] ?? 3;
    return nivelA - nivelB;
  });
};

export const useMtBtProcedimentos = (nsirId) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!nsirId) {
      setData(null);
      return undefined;
    }
    // Resposta de uma NSIR anterior não pode sobrescrever a atual.
    let cancelado = false;
    const fetchProcedimentos = async () => {
      setLoading(true);
      try {
        const response = await BaseService.get({ url: `nsirs/${nsirId}/mtbt/procedimentos` });
        if (!cancelado) setData(response?.data || vazio);
      } catch {
        if (!cancelado) setData(vazio);
      } finally {
        if (!cancelado) setLoading(false);
      }
    };
    fetchProcedimentos();
    return () => {
      cancelado = true;
    };
  }, [nsirId]);

  return {
    data,
    loading,
    gerais: idsGerais(data),
    contagem: (nsmpId) => contagemProcedimentosServico(data, nsmpId),
  };
};

export default useMtBtProcedimentos;
